import moment from 'moment';
import { DISPLAY_FORMAT } from '../constants';

/**
 * Validate a string as a date
 *
 * @param {string} input - value being tested
 * @returns {object}
 */
export default function DateValidator({ input, format }) {
    const parsed = {
        isValid: false,
        isValidMoment: false,
        moment: null,
        formattedValue: null,
        errorMessage: null
    };
    const formats = [
        'MM-DD-YYYY',
        'M-D-YY'
    ];

    if (typeof format === 'string' && format.length) {
        formats.push(format);
    }

    if (typeof input === 'string' && input.length) {
        parsed.moment = moment(input, formats);

        if (parsed.moment.isValid()) {
            parsed.isValidMoment = true;
            parsed.formattedValue = parsed.moment.format(DISPLAY_FORMAT);
            parsed.isValid = true;
        }
        else {
            // moment couldn't parse the date
            parsed.errorMessage = 'is invalid.';
            return parsed;
        }

        return parsed;
    }
}
